module.exports = __webpack_public_path__ + "img/bidders.8f76c8a6.svg";